import React from 'react'
import ReactTooltip from 'react-tooltip'

let expandableTextCounter = 0

type ExpandableTextProps = { text: string; maxLength?: number }
type ExpandableTextState = { expanded: boolean; id: string }

export class ExpandableText extends React.Component<ExpandableTextProps, ExpandableTextState> {
  state: ExpandableTextState = { expanded: false, id: `et-${++expandableTextCounter}` }

  render() {
    const { text, maxLength = 25 } = this.props
    const { expanded, id } = this.state

    if (!text) {
      return null
    }

    if (text.length <= maxLength) {
      return <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</span>
    }

    return (
      <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        <span data-tip data-for={id}>
          {expanded ? text : `${text.slice(0, maxLength)}...`}
        </span>
        {!expanded && (
          <ReactTooltip id={id} type="dark" effect="solid" place="top">
            <span style={{ maxWidth: 320, display: 'block', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {text}
            </span>
          </ReactTooltip>
        )}{' '}
        <button
          style={{
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            color: '#106ba3',
            background: 'none',
            border: 'none',
            padding: 0,
            font: 'inherit',
          }}
          onClick={(e) => {
            e.stopPropagation()
            this.setState({ expanded: !expanded })
          }}
        >
          {expanded ? 'show less' : 'show more'}
        </button>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/expandable-text.tsx